import { inject, injectable } from 'inversify';
import HttpClient from '../../../http';
import { backendUrl } from 'src/config';
import { InAppNotification } from 'src/types/common';
import {
  InAppNotificationsServiceInterface,
  UserNotificationsReqParams,
} from 'src/features/inAppNotifications/data/service/InAppNotificationsService.types';

@injectable()
class InAppNotificationService implements InAppNotificationsServiceInterface {
  @inject(HttpClient) private readonly client!: HttpClient;

  public async getUserNotifications({
    storeSlug,
    ordering = 'order',
    accessToken,
  }: UserNotificationsReqParams) {
    return this.client
      .getClient()
      .get<InAppNotification[]>(`/notifications/${storeSlug}/`, {
        params: { ordering },
        baseURL: backendUrl,
        ...(accessToken && {
          headers: { Authorization: `Token ${accessToken}` },
        }),
      });
  }
}

export default InAppNotificationService;
